export const AvantHeader =   {
  component: "Container",
  props:{
    components:{
      Header:{
        component: "DashboardHeader",
        props:{
          selectors: ["CustomerSelector", "ProductsSelector", "LocaleSelector"],
          components:{
            Alerts: {
              component: "AlertContainer",
              props:{
                selectors: ["NoticesSelector", "ProductsSelector"],
                actions: {
                  close: "CloseHeaderNotice",
                  noticeCta: "GetWorkflowUrl"
                },
                components:{
                  AdditionalNotice: {
                    component: "CreditLineNotice",
                    props:{
                      selectors: ["CustomerCreditLineDashboardSelector"],
                      actions:{
                        close: "CloseSpecificNotice"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

export const ApplicationHeader = {
  ...AvantHeader,
  props: {
    ...AvantHeader.props,
    components: {
      ...AvantHeader.props.components,
      Header: {
        ...AvantHeader.props.components.Header,
        props: {
          ...AvantHeader.props.components.Header.props,
          passedProps: {
            headerLinks: [
              {
                id: 'contact_us',
                name: 'Contact Us',
                properties: {
                  href: 'javascript:void(0);',
                  "data-ng-click": `loadStaticModal('/shared/modals/contact_us.html')`
                }
              }
            ]
          }
        }
      }
    }
  }
}

export const AvantHome = {
  component: 'DashboardContainer',
  props:{
    components: {
      Intro: {
        component: 'DashboardGreeting',
        props:{
          selectors: ['CustomerFirstNameSelector']
        }
      },
      Elements:[
        {
          component: 'DashboardNoAction',
          props:{
            selectors: ["CustomerCanApplyNewLoanSelector"]
          }
        },
        {
          component: 'ApplicationList',
          props: {
            selectors: ['OpenApplicationListSelector'],
            actions: {
              getApplicationItemLayout: 'getApplicationItemLayout'
            }
          }
        },
        {
          component: 'ProductListComponent',
          props:{
            selectors: ['ProductsSelector'],
            actions: {
              getProductLayout: 'getProductLayout'
            }
          }
        },
        {
          component: "ClosedApplicationList",
          props: {
            selectors: ['ClosedApplicationListSelector']
          }
        },
        {
          component: "CustomerIDDisplay",
          props:{
            selectors: ["CustomerSelector"]
          }
        }
      ]
    }
  }
}
